/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
const template = html`
<custom-style>
  <style include="login-styles">
    
  </style>
  </custom-style>

        <div class=" " style="background:#F4F5F7;padding:1px;">
            <div class="content-align-center mdl-cell--12-col font-12 font-weight-700" style="margin: 8px 0 0 0;">
                <div style="border-right: 2px solid black;padding: 0px 8px;">
                    <template is="dom-if" if="{{checkTenentIdNBB()}}">
                        <a href="https://dfrng2enak67a.cloudfront.net/s3fs-public/inline-files/NBB%20Digicorp%20-%20Policy.pdf?VersionId=beeXfEUhptlF9CSjmjxnRsJ55AwAi_On" target="_blank" style="color:black;text-decoration:none;">Privacy Policy</a>
                    </template>
                    <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                        <a href="https://dfrng2enak67a.cloudfront.net/s3fs-public/inline-files/NBB%20Digicorp%20-%20Policy.pdf?VersionId=beeXfEUhptlF9CSjmjxnRsJ55AwAi_On" target="_blank" style="color:black;text-decoration:none;">Privacy Policy</a>
                    </template>
                    <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                        <a href="https://dfrng2enak67a.cloudfront.net/s3fs-public/inline-files/NBB%20Digicorp%20-%20Policy.pdf?VersionId=beeXfEUhptlF9CSjmjxnRsJ55AwAi_On" target="_blank" style="color:black;text-decoration:none;">Privacy Policy</a>
                    </template>
                </div>
                <div style="border-right: 2px solid black;padding: 0px 8px;">
                   <template is="dom-if" if="{{checkTenentIdNBB()}}">
                        <a href="https://dfrng2enak67a.cloudfront.net/s3fs-public/inline-files/NBB%20Digicorp%20-%20Disclaimer.pdf?VersionId=p8CCuMkQf.5g6bQxGe_IhLZzRoRx9V1m" target="_blank" style="color:black;text-decoration:none;">Disclaimer</a>
                   </template>
                   <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                        <a href="https://dfrng2enak67a.cloudfront.net/s3fs-public/inline-files/NBB%20Digicorp%20-%20Disclaimer.pdf?VersionId=p8CCuMkQf.5g6bQxGe_IhLZzRoRx9V1m" target="_blank" style="color:black;text-decoration:none;">Disclaimer</a>
                   </template>
                   <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                        <a href="https://dfrng2enak67a.cloudfront.net/s3fs-public/inline-files/NBB%20Digicorp%20-%20Disclaimer.pdf?VersionId=p8CCuMkQf.5g6bQxGe_IhLZzRoRx9V1m" target="_blank" style="color:black;text-decoration:none;">Disclaimer</a>
                   </template>
                </div>
                <div style="padding: 0px 8px;">
                    <template is="dom-if" if="{{checkTenentIdNBB()}}">
                        <a href="https://nbbonline.com/storage/2024/12/Digicorp-Terms-and-Conditions.pdf" target="_blank" style="color:black;text-decoration:none;">Terms and Conditions</a>
                    </template>
                    <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                        <a href="https://dfrng2enak67a.cloudfront.net/s3fs-public/2024-07/NBB%20UAE%20BOB%20Terms%20&%20Conditions.pdf?VersionId=ilZopATk7n7AgqxDWO58dJjAnbkMV2ai" target="_blank" style="color:black;text-decoration:none;">Terms and Conditions</a>
                    </template>
                    <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                        <a href="https://nbbonline.com/storage/2024/12/Digicorp-Terms-and-Conditions.pdf" target="_blank" style="color:black;text-decoration:none;">Terms and Conditions</a>
                    </template>
                </div>
            </div>

            
            <div class="content-align-center mdl-cell--12-col secondary-color font-11" style="margin: 6px 0 0 0;">
                <template is="dom-if" if="{{checkTenentIdNBB()}}">
                    <oe-i18n-msg msgid="l_copyrightsNBB" class="" style=" "></oe-i18n-msg>
                </template>
                <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                    <oe-i18n-msg msgid="l_copyrightsNBBUAE" class="" style=" "></oe-i18n-msg>
                </template>
                <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                    <oe-i18n-msg msgid="l_copyrightsNBB" class="" style=" "></oe-i18n-msg>
                </template>
            </div>
        </div>

  `;
Polymer({
    is: 'fin-page-footer',
    _template: template,
    behaviors:[corpBehaviours.appCommonBehaviour],
    properties: {
        selectedFlag: {
            type: Boolean,
            notify: true 
        },
        placeHolderName: {
            type: String,
            notify: true
        },
        privacyPolicy: {
            type: String,
            notify: true,
            value:getLabel('l_PrivacyPolicy')
        },
        Disclaimer: {
            type: String,
            notify: true,
            value:getLabel('l_Disclaimer')
        },
        TermsNCond: {
            type: String,
            notify: true,
            value:getLabel('l_TermsNCond')
        }
    },
    ready: function() { 
    },
    attached: function() {
        //  this.privacyPolicy=getLabel("l_PrivacyPolicy");
        //  this.Disclaimer=getLabel("l_Disclaimer");
        //  this.TermsNCond=getLabel("l_TermsNCond");
  }
  
});